import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';
import { candidatesApi } from '../candidatesApi';
import { candidateQueryKeys } from '../queryKeys';
import type { Candidate } from '../../types';
import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import type { AxiosError } from 'axios';

export const useUpdateCandidateInterview = (
  id: string
): UseMutationResult<Candidate, AxiosError<TFormErrorResponse>> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MutationKey.UPDATE_CANDIDATE_INTERVIEW, id],
    mutationFn: () => candidatesApi.updateCandidateInterview(id),
    onSuccess: candidate => {
      queryClient.setQueryData<Candidate>(
        candidateQueryKeys.detail(id),
        previous => (previous ? { ...previous, ...candidate } : candidate)
      );
    },
  });
};
